import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const CACHE_KEY = "zrope_penguin_enabled";

// Whether the Contextual Penguin Illustrations feature is LIVE. Cached in localStorage so the
// Network-Issue penguin can still respect the admin toggle even while the device is offline.
// Defaults to enabled when unknown (fail-open for a purely cosmetic enhancement).
export function usePenguinFlag() {
  const cached = (() => {
    try { const v = localStorage.getItem(CACHE_KEY); return v === null ? true : v === "1"; }
    catch { return true; }
  })();
  const [enabled, setEnabled] = useState(cached);

  useEffect(() => {
    let cancelled = false;
    api.get("/public/penguin-illustrations")
      .then((r) => {
        const on = !!r.data?.enabled;
        if (!cancelled) setEnabled(on);
        try { localStorage.setItem(CACHE_KEY, on ? "1" : "0"); } catch { /* ignore */ }
      })
      .catch(() => {}); // keep cached/default value on failure (e.g. offline)
    return () => { cancelled = true; };
  }, []);

  return enabled;
}
